module.exports = __webpack_public_path__ + "media/images/ig_icon-9a6dddc77333419cbdee5debe777f25d.png";